import { render, staticRenderFns } from "./LogTaskUpdates.vue?vue&type=template&id=53811e90&"
import script from "./LogTaskUpdates.vue?vue&type=script&lang=js&"
export * from "./LogTaskUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53811e90')) {
      api.createRecord('53811e90', component.options)
    } else {
      api.reload('53811e90', component.options)
    }
    module.hot.accept("./LogTaskUpdates.vue?vue&type=template&id=53811e90&", function () {
      api.rerender('53811e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/LogTaskUpdates.vue"
export default component.exports